import { render } from "./DemosPage.vue?vue&type=template&id=19d971a5&scoped=true"
import script from "./DemosPage.vue?vue&type=script&lang=js"
export * from "./DemosPage.vue?vue&type=script&lang=js"

import "./DemosPage.vue?vue&type=style&index=0&id=19d971a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d971a5"]])

export default __exports__